import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";

import styles from "./WrapperLoading.module.scss";

export const WrapperLoading = ({
  children,
  isLoading,
  className,
  isError = false,
}: {
  children: ReactNode;
  isLoading: boolean;
  className?: string;
  isError?: boolean;
}) => {
  if (isLoading) {
    return (
      <div className={`${styles.loader} ${className || ""}`}>
        <CircularProgress />
      </div>
    );
  }

  if (isError) {
    return <Navigate to="/" replace />;
  }

  return children;
};
